var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_404"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("A página que procuras não existe")]),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Voltar à homepage")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }